export default "__VITE_ASSET__A644l$os__"